"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FleetViewDashboard = function () {
  function FleetViewDashboard($q, API) {
    (0, _classCallCheck3.default)(this, FleetViewDashboard);

    this.$q = $q;
    this.API = API;
  }

  /**
   * @name getOutOfRoutePercertange
   * @desc getOutOfRoutePercertange for Vehcile/Driver.
   * @param
   *   @groupIds
   *   @groupType: Vehicle or Driver
   */


  (0, _createClass3.default)(FleetViewDashboard, [{
    key: "getOutOfRoutePercertange",
    value: function getOutOfRoutePercertange(groupIds, groupType) {
      var deferred = this.$q.defer();
      var url = "v1/OutOfRoutePercertange";

      var param = [];
      param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
      param.push.apply(param, this.API.getArrayQuery("groupType", groupType));

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (res) {
        deferred.resolve(res);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }

    /**
     * @name getOutOfRouteRatioReport
     * @desc getOutOfRouteRatioReport for Vehcile/Driver.
     * @param
     *   @weeks: number of weeks to retrieve 
     *   @groupIds
     *   @groupType: Vehicle or Driver
     */

  }, {
    key: "getOutOfRouteRatioReport",
    value: function getOutOfRouteRatioReport(weeks, groupIds, groupType) {
      var deferred = this.$q.defer();
      var url = "v1/OutOfRouteRatioReport";

      var param = [];
      param.push.apply(param, this.API.getArrayQuery("weeks", weeks));
      param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
      param.push.apply(param, this.API.getArrayQuery("groupType", groupType));

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (res) {
        deferred.resolve(res);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }

    /**
     * @name getOutOfRouteReport
     * @desc getOutOfRouteReport for Vehcile/Driver.
     * @param
     *   @groupIds
     *   @groupType: Vehicle or Driver
     */

  }, {
    key: "getOutOfRouteReport",
    value: function getOutOfRouteReport(groupIds, groupType) {
      var deferred = this.$q.defer();
      var url = "v1/OutOfRouteReport";

      var param = [];
      param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
      param.push.apply(param, this.API.getArrayQuery("groupType", groupType));

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (res) {
        deferred.resolve(res);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }

    /**
     * @name getRoutesByWeek
     * @desc getRoutesByWeek for Vehcile/Driver.
     * @param
     *   @weeks: number of weeks to retrieve 
     *   @groupIds
     *   @groupType: Vehicle or Driver
     */

  }, {
    key: "getRoutesByWeek",
    value: function getRoutesByWeek(weeks, groupIds, groupType) {
      var deferred = this.$q.defer();
      var url = "v1/RoutesByWeek";

      var param = [];
      param.push.apply(param, this.API.getArrayQuery("weeks", weeks));
      param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
      param.push.apply(param, this.API.getArrayQuery("groupType", groupType));

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (res) {
        deferred.resolve(res);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }

    /**
     * @name getSummary
     * @desc get summary for Vehcile/Driver including: unit count, averageOORMiles, averageOORTime, averageOoRString, 
     *   maxOORMiles, maxOORTime and maxOoRString
     * @param 
     *   @groupIds
     *   @groupType: Vehicle or Driver
     */

  }, {
    key: "getSummary",
    value: function getSummary(groupIds, groupType) {
      var deferred = this.$q.defer();
      var url = "v1/Summary";

      var param = [];
      param.push.apply(param, this.API.getArrayQuery("groupIds", groupIds));
      param.push.apply(param, this.API.getArrayQuery("groupType", groupType));

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (res) {
        deferred.resolve(res);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);
  return FleetViewDashboard;
}();

exports.default = FleetViewDashboard;


FleetViewDashboard.$inject = ["$q", "FleetViewAPI"];


// WEBPACK FOOTER //
// ./app/alk-fleetview/fleetview.dashboard.js